import React, {Component} from 'react';
import {Button, Form} from 'react-bootstrap';
import {createForm} from "../../util/form";
import {inject, observer} from 'mobx-react';
import Select from 'react-select';
import AsyncSelect from 'react-select/lib/Async';
import Swal from 'sweetalert2'

@inject('EventStore', 'MemberStore')
@observer
export class MemberCodePreRegisterForm extends Component {
    constructor(props) {
        super(props);
        this.timeout = null;
        this.handleSubmit = this.handleSubmit.bind(this);
        this.memberFormsBuilder = [
            {
                label: 'รหัสสมาชิก',
                name: 'mcode',
                type: 'text',
                bsClass: 'form-control',
                placeholder: 'รหัสสมาชิก',
            },
        ];

        this.items = [
            {value: 'chocolate', label: 'Chocolate'},
            {value: 'strawberry', label: 'Strawberry'},
            {value: 'vanilla', label: 'Vanilla'}
        ];

        this.state = {
            validate: false,
            validateList: {},
            selectedOption: 'Test',
            onPress: false
        };
        this.memberFormsBuilder.map(x => this.state.validateList[x.name] = false);
    }


    async handleSubmit(event) {
        event.preventDefault();
        const formData = event.target;
        const mCode = formData['member'].value;
        const body = {
            type: 'member'
        };
        // this.props.EventStore.register(body);
        const response = await this.props.EventStore.preRegister(this.props.event, mCode.toUpperCase(), this.props.group);
        console.log(body, response);

        if (response['status'] > 400 && response['status'] < 500) {
            Swal({
                title: 'Error!',
                text: 'ลงทะเบียนซ้ำ',
                type: 'error',
                confirmButtonText: 'Cool'
            }).then((result) => {
                window.location.reload();
                // this.props.EventStore.reInit();
            });
        }
        else if (response.result === 'FAIL' || response['status'] >= 500) {
            Swal({
                title: 'Error!',
                text: 'ไม่สามารถลงทะเบียนได้เนื่องจากไม่ได้ละทะเบียนล่วงหน้ากรุณาติดต่อเจ้าหน้าที่',
                type: 'error',
                confirmButtonText: 'Cool'
            }).then((result) => {
                window.location.reload();
            });
        } else {
            Swal({
                title: 'เสร็จสิ้น!',
                text: 'ลงทะเบียนเสร็จสมบูรณ์',
                confirmButtonText: 'Cool'
            }).then((result) => {
                window.location.reload();
            });
        }
    }

    getEvent() {
        if (this.props.EventStore.event) {
            return (<p>{this.props.EventStore.event.name}</p>);
        }
    }

    handleChange = (selectedOption) => {
        this.setState({selectedOption});
        console.log(`Option selected:`, selectedOption);
    };

    fetchMember = async (inputValue) => {
        const item = await this.props.EventStore.searchMember(inputValue.toUpperCase());
        return item;
    };

    promiseOptions = inputValue =>
        new Promise(resolve => {
            if (inputValue === '') {
                console.log('empty');
                resolve(this.props.EventStore.memberOption);
            }
            if (this.timeout !== null) {
                clearTimeout(this.timeout);
                console.log('start new')
            }

            this.timeout = setTimeout(() => {
                console.log('timeout', inputValue);
                resolve(this.fetchMember(inputValue));
            }, 1000);
        });

    render() {
        let text = 'ลงทะเบียนร่วมงาน';
        if (this.props.group === 'Champion') {
            text = 'ลงทะเบียนขึ้นรับสูทสามารถ';
        }
        return (
            <div className="member-register-form">
                <Form onSubmit={this.handleSubmit}>
                    <div className="form-header">
                        <p>{text}</p>
                        {this.getEvent()}
                        <h4>กรุณากรอกรหัสสมาชิกหรือชื่อ</h4>
                    </div>
                    <div className="form-body" style={{height: 60}}>
                        <AsyncSelect
                            name="member"
                            cacheOptions
                            onChange={this.handleChange.bind(this)}
                            loadOptions={this.promiseOptions.bind(this)}
                            defaultOptions
                        />
                    </div>
                    <div className="form-footer">
                        <Button
                            type='submit'
                            bsStyle='primary'
                        >
                            ลงทะเบียน
                        </Button>
                    </div>

                </Form>
            </div>

        )
    }


}

export default MemberCodePreRegisterForm;


// WEBPACK FOOTER //
// ./src/component/event/PreRegisterCodeForm.jsx